import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Label } from "@/components/ui/label";
import { CURRENCIES } from "@/lib/currencies";
import { cn } from "@/lib/utils";

// Searchable currency selector (ISO 4217 + crypto). Same UX pattern as CountrySelect.
export function CurrencySelect({ label, value, onChange, placeholder = "Currency...", testId, triggerClass }) {
  const [open, setOpen] = useState(false);
  const sel = CURRENCIES.find((c) => c.code === value);
  return (
    <div className={cn(!label && "contents")}>
      {label && <Label className="mb-1.5 block text-xs font-medium text-muted-foreground">{label}</Label>}
      <Popover open={open} onOpenChange={setOpen} modal>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId} role="combobox"
            className={cn("flex h-10 w-full items-center justify-between rounded-md border border-white/[0.1] bg-[#0A0A0A] px-3 text-sm text-foreground outline-none transition-colors hover:border-white/20 focus:border-white/25", triggerClass)}>
            <span className={cn("truncate", !sel && !value && "text-muted-foreground")}>
              {sel ? sel.code : value || placeholder}
            </span>
            <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[280px] border-white/[0.1] bg-[#1a1a1e] p-0" align="start">
          <Command className="bg-transparent">
            <CommandInput placeholder="Search currency..." className="text-sm" />
            <CommandList>
              <CommandEmpty>No currency found.</CommandEmpty>
              <CommandGroup>
                <CommandItem value="__none__" onSelect={() => { onChange(""); setOpen(false); }} className="text-muted-foreground">
                  — None —
                </CommandItem>
                {CURRENCIES.map((c) => (
                  <CommandItem key={c.code} value={`${c.code} ${c.name}`} data-testid={testId ? `${testId}-opt-${c.code}` : undefined}
                    onSelect={() => { onChange(c.code); setOpen(false); }}>
                    <span className="mr-2 font-mono text-xs text-foreground/90">{c.code}</span>
                    <span className="flex-1 truncate text-muted-foreground">{c.name}</span>
                    {value === c.code && <Check className="h-4 w-4" />}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
}
